import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Space } from 'antd';
import { dateToString, getFullName } from '@/utils';
import { useGetChildAdoptionsQuery } from '@/services/child-api';
import Table from '@/components/table';

const columns = [
  {
    title: 'Parents',
    dataIndex: 'parents',
    render: (value, record) => (
      <Space direction="vertical" size={0}>
        {value.map((item) => (
          <Link key={item.individualParentId} to={`/parent/${record.parentId}`}>
            {getFullName(item)}
          </Link>
        ))}
      </Space>
    ),
  },
  {
    title: 'Adoption Date',
    dataIndex: 'adoptedDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Type',
    dataIndex: 'adoptionType',
    ellipsis: true,
    render: (value) => value.name,
  },
  {
    title: 'Note',
    dataIndex: 'note',
    ellipsis: true,
  },
];

const AdoptionHistory = ({ childId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetChildAdoptionsQuery({ childId, pageNumber });

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="childAdoptionId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(AdoptionHistory);
